<template>
  <embedded-crud-table
    :entity="entity"
    :entity-store="entityStore"
    :columns="columns"
    :generate-summary="generateSummary"
    :definition="definition"
    :caption="caption"
    :disabled="false"
    :parent-identifiers="parentIdentifiers"
    :open-in-fullscreen="false"
    :required="false"
    :create-item-from-form-data="createItemFromFormData"
    :create-form-data-from-item="createFormDataFromItem"
    :permission-code="'Domain'"
    :disable-sorting="true"
  />
</template>

<script>
import EmbeddedCrudTable from '@/components/crud/EmbeddedCrudTable';
import formMixin from './form-mixin';

export default {
  components: {
    EmbeddedCrudTable
  },
  mixins: [formMixin],
  props: {
    caption: String,
    parentIdentifiers: {
      type: Object,
      default: () => null
    },
    permissionCode: String,
    parentID: Number
  },
  data() {
    return {
      columns: [
        { field: 'priceListItemDescription', label: 'linkPriceListItem.priceListItemDescription' },
        { field: 'finishesDescription', label: 'linkPriceListItem.finishesDescription' },
        {
          field: 'blackoutYN',
          label: 'fabric.blackout',
          formatter: this.formatBoolean,
          filter: { type: 'none' },
          sortable: false
        },
        {
          field: 'veloursYN',
          label: 'productType.velours',
          formatter: this.formatBoolean,
          filter: { type: 'none' },
          sortable: false
        }
      ]
    };
  },
  methods: {
    generateSummary(row) {
      const summary = `${row.productGroupDescription}`;
      return summary;
    },
    formatBoolean(row, column, cellValue) {
      return cellValue ? this.$t('common.yes') : this.$t('common.no');
    }
  }
};
</script>

<style scoped></style>
